var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoForecast = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 13,
  r: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "m15 16 1-1 1-1 1-1 1-1-1-1-1-1-1-1-1-1-1 1-1 1-1 1-1 1 1 1 1 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11 12 1-1-1-1-1 1zM19 12l1-1-1-1-1 1zM11 17l1-1-1-1-1 1zM19 17l1-1-1-1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 22a4 4 0 0 0 0-8 3.82 3.82 0 0 0-3.18 1.695A8.93 8.93 0 0 0 17.6 14a7.6 7.6 0 0 0 0 15.2H26a4 4 0 0 0 0-8z"
}))));
export default SvgNoForecast;